import { randoms } from "lib/utils"

export const compellingEvidence = [
  {
    refstr: randoms.string(12, "a#"),
    title: "Check for Product",
    description: "Has content for whether a product exists or not.",
    visible: true,
    if_passes: "content",
    if_fails: "content",
    nested: {
      if_passes: null,
      if_fails: null
    },
    conditional: {
      source_id: null,
      name: "Conditional Statement",
      description: "",
      zones: [
        {
          zoneref: "mv434bzn",
          groups: [
            {
              groupref: "t8v8ghdn",
              items: [
                "t8v8ghdn"
              ]
            }
          ]
        }
      ],
      items: [
        {
          refid: "t8v8ghdn",
          source: "api",
          location: "dropzone",
          operator: "mustBeGt",
          tag: "",
          value: "0",
          apiValueObj: {
            useInContent: "false",
            _id: "678d28d664348d2a78e5a518",
            origin: "Representment",
            parent: "rp.OrderInfo",
            path: "rp.OrderInfo.Products",
            label: "Products",
            description: "This is an array in the API, but what goes in here?",
            type: "array",
            hiddenType: "array",
            placeholder: "RpOrInPro",
            needsReview: true,
            __v: 0
          },
          alias: "At least 1 product",
          conversion: "getCount"
        }
      ],
      clipboard: []
    },
    content: {
      pass: "<p><span>On [[rp.RepresentmentTransactionInfo.TransactionDate::date]], [[rp.OrderInfo.BillingContact.Name]] authorized an order for [[rp.OrderInfo.Products::count]] in the amount of [[rp.RepresentmentTransactionInfo.TransactionAmount::usd]].</span></p>",
      fail: "<p><span>On [[rp.RepresentmentTransactionInfo.TransactionDate::date]], [[rp.OrderInfo.BillingContact.Name]] authorized an order in the amount of [[rp.RepresentmentTransactionInfo.TransactionAmount::usd]].</span></p>"
    },
    parent: [
      "[root]"
    ],
    level: 1,
    parentResult: "any"
  },
  {
    refstr: randoms.string(12, "a#"),
    title: "AVS Code Check",
    description: "",
    visible: true,
    if_passes: "content",
    if_fails: "nothing",
    nested: {
      if_passes: null,
      if_fails: null
    },
    conditional: {
      source_id: null,
      name: "Conditional Statement",
      description: "",
      zones: [
        {
          zoneref: "eeq2tw2k",
          groups: [
            {
              groupref: "hr4bbn3t",
              items: [
                "hr4bbn3t"
              ]
            }
          ]
        }
      ],
      items: [
        {
          refid: "hr4bbn3t",
          source: "api",
          location: "dropzone",
          operator: "mustBeGt",
          tag: "",
          value: "0",
          apiValueObj: {
            _id: "678d28d664348d2a78e5a4f6",
            origin: "Representment",
            parent: "rp.RepresentmentTransactionInfo",
            path: "rp.RepresentmentTransactionInfo.AVSCode",
            label: "AVSCode",
            useInContent: "true",
            type: "string",
            hiddenType: "string",
            placeholder: "RpRepTrxInCod",
            needsReview: false,
            __v: 0
          }
        }
      ],
      clipboard: []
    },
    content: {
      pass: "<p><span>The transaction returned a positive AVS Match Code of [[rp.RepresentmentTransactionInfo.AVSCode]] where the address and postal code provided matches the information on file with the Cardholder's bank</span></p>",
      fail: ""
    },
    parent: [
      "[root]"
    ],
    level: 1,
    parentResult: "any"
  },
  {
    refstr: randoms.string(12, "a#"),
    title: "ThreeDSecure ID Check",
    description: "Check for ThreeD Secure",
    visible: true,
    if_passes: "content",
    if_fails: "nothing",
    nested: {
      if_passes: null,
      if_fails: null
    },
    conditional: {
      source_id: null,
      name: "Conditional Statement",
      description: "",
      zones: [
        {
          zoneref: "ihmiif0j",
          groups: [
            {
              groupref: "9h2vh025",
              items: [
                "9h2vh025"
              ]
            }
          ]
        }
      ],
      items: [
        {
          refid: "9h2vh025",
          source: "api",
          location: "dropzone",
          operator: "mustBe",
          tag: "",
          value: "Y",
          apiValueObj: {
            _id: "678d28d664348d2a78e5a4f9",
            origin: "Representment",
            parent: "rp.RepresentmentTransactionInfo",
            path: "rp.RepresentmentTransactionInfo.ThreeDSecure_Id",
            label: "ThreeDSecure_Id",
            useInContent: "true",
            type: "null",
            hiddenType: "null",
            placeholder: "RpRepTrxInThrSecId",
            needsReview: true,
            __v: 0
          }
        }
      ],
      clipboard: []
    },
    content: {
      pass: "<p><span>The transaction obtained a 3D Secure code of [[rp.RepresentmentTransactionInfo.ThreeDSecure_Id]] confirming a successful authentication of the transaction which shifts the liability of the charge to the issuing bank.</span></p>",
      fail: ""
    },
    parent: [
      "[root]"
    ],
    level: 1,
    parentResult: "any"
  },
  {
    refstr: randoms.string(12, "a#"),
    title: "CVV Check",
    description: "Check for CVV",
    visible: true,
    if_passes: "content",
    if_fails: "nothing",
    nested: {
      if_passes: null,
      if_fails: null
    },
    conditional: {
      source_id: null,
      name: "Conditional Statement",
      description: "",
      zones: [
        {
          zoneref: "0f82aa8p",
          groups: [
            {
              groupref: "gxkl20ja",
              items: [
                "ysxelws7",
                "q2aam0qd"
              ]
            }
          ]
        }
      ],
      items: [
        {
          refid: "q2aam0qd",
          source: "api",
          location: "dropzone",
          operator: "mustBe",
          tag: "",
          value: "1",
          apiValueObj: {
            _id: "678d28d664348d2a78e5a4f8",
            origin: "Representment",
            parent: "rp.RepresentmentTransactionInfo",
            path: "rp.RepresentmentTransactionInfo.CVSMatchCode_Id",
            label: "CVSMatchCode_Id",
            useInContent: "true",
            description: "The CVS or CVV code associated with the order.",
            type: "number",
            hiddenType: "number",
            placeholder: "RpRepTrxInMatCodId",
            needsReview: false,
            __v: 0
          }
        },
        {
          refid: "ysxelws7",
          source: "api",
          location: "dropzone",
          operator: "mustBe",
          tag: "",
          value: "M",
          apiValueObj: {
            _id: "678d28d664348d2a78e5a4f8",
            origin: "Representment",
            parent: "rp.RepresentmentTransactionInfo",
            path: "rp.RepresentmentTransactionInfo.CVSMatchCode_Id",
            label: "CVSMatchCode_Id",
            useInContent: "true",
            description: "The CVS or CVV code associated with the order.",
            type: "number",
            hiddenType: "number",
            placeholder: "RpRepTrxInMatCodId",
            needsReview: false,
            __v: 0
          }
        }
      ],
      clipboard: []
    },
    content: {
      pass: "<p><span>The transaction returned a positive CVV/CVC Match Code of [[rp.RepresentmentTransactionInfo.CVSMatchCode_Id]] -- confirming that the CVV code provided matches the information on file with the Cardholder's bank.</span></p>",
      fail: ""
    },
    parent: [
      "[root]"
    ],
    level: 1,
    parentResult: "any"
  },
  {
    refstr: randoms.string(12, "a#"),
    title: "Auth Code Check",
    description: "Check for Auth Code",
    visible: true,
    if_passes: "content",
    if_fails: "nothing",
    nested: {
      if_passes: null,
      if_fails: null
    },
    conditional: {
      source_id: null,
      name: "Conditional Statement",
      description: "",
      zones: [
        {
          zoneref: "tveqp5wz",
          groups: [
            {
              groupref: "2zz703rv",
              items: [
                "2zz703rv"
              ]
            }
          ]
        }
      ],
      items: [
        {
          refid: "2zz703rv",
          source: "api",
          location: "dropzone",
          operator: "mustExist",
          tag: "",
          value: "",
          apiValueObj: {
            useInContent: "false",
            _id: "678d28d664348d2a78e5a4e8",
            origin: "Representment",
            parent: "rp.RepresentmentTransactionInfo",
            path: "rp.RepresentmentTransactionInfo.AuthCode",
            label: "AuthCode",
            type: "string",
            hiddenType: "number",
            placeholder: "RpRepTrxInAutCod",
            needsReview: false,
            __v: 0
          }
        }
      ],
      clipboard: []
    },
    content: {
      pass: "<p><span>An Authorization Code [[rp.RepresentmentTransactionInfo.AuthCode]] was obtained on [[rp.RepresentmentTransactionInfo.TransactionDate]] confirming that the issuing bank authorized the charge.</span></p>",
      fail: ""
    },
    parent: [
      "[root]"
    ],
    level: 1,
    parentResult: "any"
  },
  {
    refstr: randoms.string(12, "a#"),
    title: "Device ID Check",
    description: "Check for Device ID",
    visible: true,
    if_passes: "content",
    if_fails: "nothing",
    nested: {
      if_passes: null,
      if_fails: null
    },
    conditional: {
      source_id: null,
      name: "Conditional Statement",
      description: "",
      zones: [
        {
          zoneref: "mfuhvrqn",
          groups: [
            {
              groupref: "5mvmdaus",
              items: [
                "5mvmdaus"
              ]
            }
          ]
        }
      ],
      items: [
        {
          refid: "5mvmdaus",
          source: "api",
          location: "dropzone",
          operator: "mustExist",
          tag: "",
          value: "",
          apiValueObj: {
            useInContent: "false",
            _id: "678d28d664348d2a78e5a4f0",
            origin: "Representment",
            parent: "rp.RepresentmentTransactionInfo",
            path: "rp.RepresentmentTransactionInfo.DeviceId",
            label: "DeviceId",
            type: "null",
            hiddenType: "null",
            placeholder: "RpRepTrxInDevId",
            needsReview: true,
            __v: 0
          }
        }
      ],
      clipboard: []
    },
    content: {
      pass: "<p><span>This transaction included confirmation of the Device ID of the smartphone or tablet used when the customer authorized the charge.</span></p>",
      fail: ""
    },
    parent: [
      "[root]"
    ],
    level: 1,
    parentResult: "any"
  },
  {
    refstr: randoms.string(12, "a#"),
    title: "IP Address Check",
    description: "Check for IP Address",
    visible: true,
    if_passes: "content",
    if_fails: "nothing",
    nested: {
      if_passes: null,
      if_fails: null
    },
    conditional: {
      source_id: null,
      name: "Conditional Statement",
      description: "",
      zones: [
        {
          zoneref: "moa89lbi",
          groups: [
            {
              groupref: "5010spcb",
              items: [
                "5010spcb"
              ]
            }
          ]
        }
      ],
      items: [
        {
          refid: "5010spcb",
          source: "api",
          location: "dropzone",
          operator: "mustExist",
          tag: "",
          value: "",
          apiValueObj: {
            _id: "678d28d664348d2a78e5a50e",
            origin: "Representment",
            parent: "rp.RepresentmentTransactionInfo",
            path: "rp.RepresentmentTransactionInfo.IPAddress",
            label: "IPAddress",
            useInContent: "true",
            type: "string",
            hiddenType: "string",
            placeholder: "RpRepTrxInAdr",
            needsReview: false,
            __v: 0
          }
        }
      ],
      clipboard: []
    },
    content: {
      pass: "<p><span>The IP address [[rp.RepresentmentTransactionInfo.IPAddress]] was used on the device where the transaction was made, which identifies the internet or local network used by the customer.</span></p>",
      fail: ""
    },
    parent: [
      "[root]"
    ],
    level: 1,
    parentResult: "any"
  },
  {
    refstr: randoms.string(12, "a#"),
    title: "GeoID Check",
    description: "Check for GeoID",
    visible: true,
    if_passes: "content",
    if_fails: "nothing",
    nested: {
      if_passes: null,
      if_fails: null
    },
    conditional: {
      source_id: null,
      name: "Conditional Statement",
      description: "",
      zones: [
        {
          zoneref: "bduzjtbq",
          groups: [
            {
              groupref: "22ehklkb",
              items: [
                "22ehklkb"
              ]
            }
          ]
        }
      ],
      items: [
        {
          refid: "22ehklkb",
          source: "api",
          location: "dropzone",
          operator: "mustExist",
          tag: "",
          value: "",
          apiValueObj: {
            useInContent: "false",
            _id: "678d28d664348d2a78e5a4f1",
            origin: "Representment",
            parent: "rp.RepresentmentTransactionInfo",
            path: "rp.RepresentmentTransactionInfo.GeoId",
            label: "GeoId",
            type: "null",
            hiddenType: "null",
            placeholder: "RpRepTrxInGeoId",
            needsReview: true,
            __v: 0
          }
        }
      ],
      clipboard: []
    },
    content: {
      pass: "<p><span>At the time of the transaction the GEO Location of the IP address used was [[rp.RepresentmentTransactionInfo.GeoId]].</span></p>",
      fail: ""
    },
    parent: [
      "[root]"
    ],
    level: 1,
    parentResult: "any"
  }
]




const datapoints = {
  products: "[[rp.OrderInfo.Products]]",
  trxDate: "[[rp.RepresentmentTransactionInfo.TransactionDate]]",
  trxAmount: "[[rp.RepresentmentTransactionInfo.TransactionAmount]]",
  billingContactName: "[[rp.OrderInfo.BillingContact.Name]]",
  avsMatchCode: "[[rp.RepresentmentTransactionInfo.AVSCode]]",
  cvvMatchCode: "[[rp.RepresentmentTransactionInfo.CVSMatchCode_Id]]",
  authCode: "[[rp.RepresentmentTransactionInfo.AuthCode]]",
  threeDSecureId: "[[rp.RepresentmentTransactionInfo.ThreeDSecure_Id]]",
  deviceId: "[[rp.RepresentmentTransactionInfo.DeviceId]]",
  ipAddress: "[[rp.RepresentmentTransactionInfo.IPAddress]]",
  geoId: "[[rp.RepresentmentTransactionInfo.GeoId]]"
}




/* products > 0:
   true:  On [[rp.RepresentmentTransactionInfo.TransactionDate]], [[rp.OrderInfo.BillingContact.Name]] authorized an order for [[rp.OrderInfo.Products::count]] in the amount of [[rp.RepresentmentTransactionInfo.TransactionAmount]]
    
   false:  On [[rp.RepresentmentTransactionInfo.TransactionDate]], [[rp.OrderInfo.BillingContact.Name]] authorized an order in the amount of [[rp.RepresentmentTransactionInfo.TransactionAmount]].

  
   data.avsMatchCode?.length > 0
   true: The transaction returned a positive AVS Match Code of [[rp.RepresentmentTransactionInfo.AVSCode]] where the address and postal code provided matches the information on file with the Cardholder's bank.


${ (data.cvvMatchCode === 1 || data.cvvMatchCode === "M") ? `
 <li>The transaction returned a positive CVV/CVC Match Code of [[rp.RepresentmentTransactionInfo.CVSMatchCode_Id]] -- confirming that the CVV code provided matches the information on file with the Cardholder's bank.</li>
` : ''}

${ data.authCode !== null ? `
  <li>An Authorization Code [[rp.RepresentmentTransactionInfo.AuthCode]] was obtained on [[rp.RepresentmentTransactionInfo.TransactionDate]] confirming that the issuing bank authorized the charge.</li>
`: ''}

${ data.threeDSecureId === "Y" ? `
  <li>The transaction obtained a 3D Secure code of [[rp.RepresentmentTransactionInfo.ThreeDSecure_Id]] confirming a successful authentication of the transaction which shifts the liability of the charge to the issuing bank.</li>
`: ''}

${ data.deviceId !== null ? `
  <li>This transaction included confirmation of the Device ID of the smartphone or tablet used when the customer authorized the charge.</li>
`: ''}

${ data.ipAddress !== null ? `
  <li>The IP address [[rp.RepresentmentTransactionInfo.IPAddress]] was used on the device where the transaction was made, which identifies the internet or local network used by the customer.</li>
`: ''}

${ data.geoId !== null ? `
  <li>At the time of the transaction the GEO Location of the IP address used was [[rp.RepresentmentTransactionInfo.GeoId]].</li>
`: ''}

*/